import { DataBean } from "../DataBean";

export class DocumentatioPage extends DataBean {

  public async getDocumentatioPageCatalogLike(nombrePropiedad: string, value: string, maxRows: number): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.List_getDocumentatioPageCatalogLike_String_String_Number",
      [nombrePropiedad, value, maxRows]
    );
  }

  public async getPageDocumentationRender(page: number, rows: number, props: Record<string, any>): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getPageDocumentationRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getPageDocumentationHtml(idPage: number): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "String_getPageDocumentationHtml_Number",
      [idPage]
    );
  }

  public async updateDocumentatioPage(bean: any): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.cache.bean.DocumentatioPage_updateDocumentatioPage_com.advantage.cache.bean.DocumentatioPage",
      [
        {
          "DataBeanProperties": bean,
          "DataBeanName": "com.advantage.cache.bean.DocumentatioPage"
        }
      ]
    );
  }

  public async deleteDocumentatioPage(iddocumentatiopage: number): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "boolean_deleteDocumentatioPage_Number",
      [iddocumentatiopage]
    );
  }

  public async getPages(page: number, rows: number, nameLike: string): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.List_getPages_Number_Number_String",
      [page, rows, nameLike]
    );
  }

}
